import React, { useEffect } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { Route, Switch } from 'react-router-dom';

import { fetchUserSounds } from 'flow/actions/sounds-actions';
import PbxQueueWaitingSound from 'flow/components/pbx/PbxQueueWaitingSound';
import PbxSettingsEditName from 'flow/components/pbx/PbxSettingsEditName';
import PbxTicketsSettings from 'flow/components/pbx/PbxTicketsSettings';
import PbxTicketsSettingsCreation from 'flow/components/pbx/PbxTicketsSettingsCreation';
import PbxTicketsSettingsVisibility from 'flow/components/pbx/PbxTicketsSettingsVisibility';
import PbxWelcomeMessage from 'flow/components/pbx/PbxWelcomeMessage';
import PbxWelcomeMessageClosed from 'flow/components/pbx/PbxWelcomeMessageClosed';
import PbxWelcomeMessageClosedProfileSound from 'flow/components/pbx/PbxWelcomeMessageClosedProfileSound';
import PbxWelcomeMessageOpen from 'flow/components/pbx/PbxWelcomeMessageOpen';
import PbxWelcomeMessageProfileRedirect from 'flow/components/pbx/PbxWelcomeMessageProfileRedirect';
import PbxWelcomeMessageSounds from 'flow/components/pbx/PbxWelcomeMessageSounds';
import QueueStatistics from 'flow/components/pbx/QueueStatistics';
import PbxSettings from 'flow/components/PbxSettings';
import PbxCallStrategy from 'flow/route-components/PbxCallStrategy';
import PbxCallStrategyEdit from 'flow/route-components/PbxCallStrategyEdit';
import PbxQueueCalendar from 'flow/route-components/PbxQueueCalendar';
import PbxQueueMember from 'flow/route-components/PbxQueueMember';
import PbxQueueMemberEdit from 'flow/route-components/PbxQueueMemberEdit';
import AutoReplyMessage from 'flow/route-components/AutoReplyMessage';
import PbxAutoReply from 'flow/route-components/PbxAutoReply';
import { routes } from 'flow/types/routes';

const PbxQueueSettingsRoutes = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchUserSounds());
    }, []);

    return (
        <Switch>
            <Route
                path={routes['pbx.queues.entityKey.settings.edit.name']}
                component={PbxSettingsEditName}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.waitingsound']}
                component={PbxQueueWaitingSound}
            />
            <Route
                path={
                    routes['pbx.queues.entityKey.settings.welcomemessage.open']
                }
                component={PbxWelcomeMessageOpen}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.settings.welcomemessage.sounds'
                    ]
                }
                component={PbxWelcomeMessageSounds}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.settings.welcomemessage.profileKey.sound'
                    ]
                }
                component={PbxWelcomeMessageClosedProfileSound}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.settings.welcomemessage.profileKey.redirect'
                    ]
                }
                component={PbxWelcomeMessageProfileRedirect}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.settings.welcomemessage.profileKey'
                    ]
                }
                component={PbxWelcomeMessageClosed}
            />

            <Route
                path={routes['pbx.queues.entityKey.settings.welcomemessage']}
                component={PbxWelcomeMessage}
            />
            <Route
                path={routes['pbx.queues.queueKey.settings.callstrategy.edit']}
                component={PbxCallStrategyEdit}
            />
            <Route
                path={routes['pbx.queues.queueKey.settings.callstrategy']}
                component={PbxCallStrategy}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.statistics']}
                component={QueueStatistics}
            />
            <Route
                path={routes['pbx.queues.queueKey.settings.members.edit']}
                component={PbxQueueMemberEdit}
            />
            <Route
                path={routes['pbx.queues.queueKey.settings.members']}
                component={PbxQueueMember}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.calendar']}
                component={PbxQueueCalendar}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.tickets.create']}
                component={PbxTicketsSettingsCreation}
            />
            <Route
                path={
                    routes['pbx.queues.entityKey.settings.tickets.visibility']
                }
                component={PbxTicketsSettingsVisibility}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.tickets']}
                component={PbxTicketsSettings}
            />
            <Route
                path={
                    routes[
                        'pbx.queues.entityKey.settings.autoreply.profileKey.messageType'
                    ]
                }
                component={AutoReplyMessage}
            />
            <Route
                path={
                    routes['pbx.queues.entityKey.settings.autoreply.profileKey']
                }
                component={AutoReplyMessage}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings.autoreply']}
                component={PbxAutoReply}
            />
            <Route
                path={routes['pbx.queues.entityKey.settings']}
                component={PbxSettings}
            />
        </Switch>
    );
};

export default PbxQueueSettingsRoutes;
